import React from 'react';
import CertificationBadges from './components/CertificationBadges';
import GitHubActivity from './components/GitHubActivity';
import LearningJourney from './components/LearningJourney';
import SkillCard, { SkillsGrid } from './components/SkillCard';
import SkillMatrix from './components/SkillMatrix';
import TechnologyRadar from './components/TechnologyRadar';

const Skills = () => {
  return (
  <div className="container mx-auto px-4 pt-20 md:pt-24 pb-12">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-6">
          <section>
            <h2 className="text-2xl font-bold mb-4">My Skills</h2>
            <p className="text-muted-foreground mb-6">A practical breakdown of tools, frameworks and techniques I use day-to-day.</p>
            <SkillsGrid />
          </section>

          <section className="mt-8">
            <h3 className="text-xl font-semibold mb-3">Skill Matrix</h3>
            <SkillMatrix />
          </section>

          <section className="mt-8">
            <h3 className="text-xl font-semibold mb-3">Learning Journey</h3>
            <LearningJourney />
          </section>

          <section className="mt-8">
            <h3 className="text-xl font-semibold mb-3">Certifications</h3>
            <CertificationBadges />
          </section>
        </div>

        <aside className="space-y-6">
          <div>
            <h3 className="text-lg font-semibold mb-2">GitHub Activity</h3>
            <GitHubActivity />
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2">Technology Radar</h3>
            <TechnologyRadar />
          </div>

        </aside>
      </div>
    </div>
  );
};

export default Skills;
